<template>
  <div class="page-transfer">
    <header>
      <h3 class="title__top">导出成功，链接已生成！</h3>
      <p class="title__bottom">你可以随时在巩固练习记录中查看导出的内容</p>
    </header>
    <section>
      <div class="test-one">
        <span>仅题目内容：</span>
        <input
          type="text"
          class="input"
          v-model="this.answerUrl[0].data.shortUrl"
          id="test-content"
        />
        <input type="button" value="打开" class="open" @click="openNew(1)" />
        <input
          type="button"
          value="复制链接"
          class="clone"
          @click="cloneUrl(1)"
        />
      </div>
      <div>
        <span>题目内容+答案解析：</span>
        <input
          type="text"
          class="input"
          v-model="this.answerUrl[1].data.shortUrl"
          id="test-answer"
        />
        <input type="button" value="打开" class="open" @click="openNew(2)" />
        <input
          type="button"
          value="复制链接"
          class="clone"
          @click="cloneUrl(2)"
        />
      </div>
      <div class="copy-content">
        <input type="text" id="copy-content__input" />
      </div>
    </section>
    <footer>
      <button @click="goBack">返回班级报告</button>
    </footer>
  </div>
</template>
<script>
import { openTab } from '@/utils';

export default {
  name: 'Transfer',
  props: {
    answerUrl: {
      default: () => [],
      typeof: Array,
    },
  },
  mounted() {
    console.log('answerUrl-----------', this.answerUrl);
  },
  methods: {
    openNew(num) {
      if (num === 1) {
        openTab(this.answerUrl[0].data.shortUrl);
      }
      if (num === 2) {
        openTab(this.answerUrl[1].data.shortUrl);
      }
    },
    cloneUrl(num) {
      const copyVal = num === 1 ? document.getElementById('test-content') : document.getElementById('test-answer');
      const input = document.getElementById('copy-content__input');
      input.value = copyVal.value;
      input.select();
      document.execCommand('copy');
      try {
        if (document.execCommand('copy', false, null)) {
          console.log('复制地址成功', input.value);
          this.$message({
            message: '复制链接成功',
            type: 'success',
          });
        } else {
          console.log('地址复制失败---------');
        }
      } catch (err) {
        console.log('地址复制失败---------1');
      }
    },
    goBack() {
      this.$emit('goBack');
    },
  },
};
</script>
<style lang="scss" scoped>
.page-transfer {
  background: #ffffff;
  padding-left: 247px;
  margin-top: 82px;
  font-family: 'PingFangSC-Regular', 'PingFang SC';
}
header {
  margin-bottom: 52px;
  .title__top {
    background: url("~@/views/pt/images/checkbox.png") no-repeat left center;
    background-size: 20px 20px;
    text-indent: 31px;
    font-size: 16px;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.8);
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 30px;
      bottom: 0px;
      width: 168px;
      height: 12px;
      background: rgba(230, 162, 60, 0.2);
      border-radius: 7px;
    }
  }
  .title__bottom {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(48, 49, 51, 0.6);
    margin-top: 15px;
  }
}
section {
  div {
    margin-top: 20px;
    height: 40px;
    line-height: 40px;
  }
  span {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
  }
  .test-one {
    padding-left: 60px;
  }
  .input {
    width: 298px;
    height: 40px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #d8dce6;
    font-size: 12px;
    line-height: 40px;
    text-indent: 8px;
  }
  .open {
    width: 80px;
    height: 36px;
    background: #ffa82d;
    border: none;
    border-radius: 4px;
    color: #ffffff;
    margin-left: 20px;
    font-size: 14px;
    line-height: 36px;
    font-weight: 500;
  }
  .clone {
    width: 80px;
    height: 36px;
    background: #1989fa;
    border: none;
    border-radius: 4px;
    color: #ffffff;
    margin-left: 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 36px;
  }
  .copy-content {
    position: absolute;
    top: -9999px;
    &__input {
      opacity: 0;
    }
  }
}
footer {
  margin-left: 231px;
  margin-top: 102px;
  button {
    min-width: 154px;
    font-size: 15px;
    height: 40px;
    background: #e6f1fc;
    border-radius: 4px;
    border: 1px solid #a3d0fd;
    color: #1989fa;
  }
}
</style>
